/* ============================================================
   Cart Drawer JS (component-cart-drawer)
   AJAX cart drawer — fetches live cart data from Shopify
   ============================================================ */
(function () {
  'use strict';

  /* Inject drawer HTML once */
  document.body.insertAdjacentHTML('beforeend', `
    <div id="CartDrawer" class="cart-drawer" aria-hidden="true" role="dialog" aria-label="Your order">
      <div class="cart-drawer__overlay js-cart-drawer-close"></div>
      <div class="cart-drawer__panel">
        <div class="cart-drawer__header">
          <button class="cart-drawer__back js-cart-drawer-close" aria-label="Back">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M13 4L7 10L13 16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <span class="cart-drawer__title">Your order</span>
          <button class="cart-drawer__close js-cart-drawer-close" aria-label="Close">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <line x1="1" y1="1" x2="15" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <line x1="15" y1="1" x2="1" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
        <div class="cart-drawer__items" id="CartDrawerItems"></div>
        <div class="cart-drawer__footer" id="CartDrawerFooter" hidden></div>
      </div>
    </div>
  `);

  const cartDrawer  = document.getElementById('CartDrawer');
  const itemsEl     = document.getElementById('CartDrawerItems');
  const footerEl    = document.getElementById('CartDrawerFooter');
  let isUpdating = false;

  function escHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(0) + ' AED';
  }

  function getVisibleItems(cart) {
    return (cart.items || []).filter(item => Number(item.quantity) > 0);
  }

  function setUpdating(updating) {
    isUpdating = updating;
    cartDrawer.classList.toggle('is-updating', updating);
    cartDrawer.querySelectorAll('.js-cd-minus, .js-cd-plus, .js-cd-remove')
      .forEach(btn => { btn.disabled = updating; });
  }

  function renderCart(cart) {
    const items = getVisibleItems(cart);

    if (items.length === 0) {
      itemsEl.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      footerEl.hidden = true;
      return;
    }

    itemsEl.innerHTML = items.map(item => {
      const imgSrc = item.image
        ? item.image.replace(/(\.[^.]+)$/, '_70x70$1')
        : '';
      const variantLine = item.variant_title && item.variant_title !== 'Default Title'
        ? `<div class="cart-drawer-item__variant">VOLUME: ${escHtml(item.variant_title)}</div>`
        : '';
      const skuLine = item.sku
        ? `<div class="cart-drawer-item__sku">${escHtml(item.sku)}</div>`
        : '';

      return `
        <div class="cart-drawer-item" data-key="${escHtml(item.key)}">
          <a href="${escHtml(item.url)}" class="cart-drawer-item__img-wrap">
            ${imgSrc ? `<img src="${escHtml(imgSrc)}" alt="${escHtml(item.product_title)}" class="cart-drawer-item__img" loading="lazy">` : ''}
          </a>
          <div class="cart-drawer-item__info">
            <a href="${escHtml(item.url)}" class="cart-drawer-item__title">${escHtml(item.product_title)}</a>
            ${variantLine}
            ${skuLine}
          </div>
          <div class="cart-drawer-item__controls">
            <div class="cart-drawer-item__qty">
              <button class="cart-drawer-item__qty-btn js-cd-minus" data-key="${escHtml(item.key)}" data-qty="${item.quantity}" aria-label="Decrease">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="8.5" stroke="currentColor"/><line x1="5" y1="9" x2="13" y2="9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
              </button>
              <span class="cart-drawer-item__qty-count">${item.quantity}</span>
              <button class="cart-drawer-item__qty-btn js-cd-plus" data-key="${escHtml(item.key)}" data-qty="${item.quantity}" aria-label="Increase">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="8.5" stroke="currentColor"/><line x1="9" y1="5" x2="9" y2="13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><line x1="5" y1="9" x2="13" y2="9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
              </button>
            </div>
            <div class="cart-drawer-item__price">${formatMoney(item.final_line_price)}</div>
          </div>
          <button class="cart-drawer-item__remove js-cd-remove" data-key="${escHtml(item.key)}" aria-label="Remove">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
              <line x1="1" y1="1" x2="9" y2="9" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <line x1="9" y1="1" x2="1" y2="9" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
      `;
    }).join('');

    footerEl.hidden = false;
    footerEl.innerHTML = `
      <div class="cart-drawer__total">Total: ${formatMoney(cart.total_price)}</div>
      <a href="/checkout" class="cart-drawer__checkout">CHECKOUT</a>
    `;
  }

  function fetchCart() {
    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    }).then(r => r.json());
  }

  async function updateItem(key, qty) {
    if (isUpdating) return;

    const nextQty = Math.max(0, Number.parseInt(qty, 10) || 0);
    setUpdating(true);

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: nextQty })
      });

      if (!res.ok) throw new Error('Cart update failed');

      const cart = await fetchCart();
      renderCart(cart);
      syncCartCount(cart.item_count);
    } catch (error) {
      try {
        const cart = await fetchCart();
        renderCart(cart);
        syncCartCount(cart.item_count);
      } catch (_error) {
        // Keep the current drawer state if Shopify cannot return a fresh cart.
      }
    } finally {
      setUpdating(false);
    }
  }

  function syncCartCount(count) {
    document.querySelectorAll('.js-cart-count').forEach(badge => {
      badge.textContent = count;
      badge.style.display = count > 0 ? '' : 'none';
    });
  }

  function openCartDrawer() {
    fetchCart().then(cart => {
      renderCart(cart);
      cartDrawer.setAttribute('aria-hidden', 'false');
      cartDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }

  function closeCartDrawer() {
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* Event delegation */
  document.addEventListener('click', e => {
    /* Open drawer when clicking cart icon in header */
    const cartBtn = e.target.closest('.site-header__cart');
    if (cartBtn) {
      e.preventDefault();
      openCartDrawer();
      return;
    }

    if (e.target.closest('.js-cart-drawer-close')) {
      closeCartDrawer();
      return;
    }

    const minus = e.target.closest('.js-cd-minus');
    if (minus) {
      updateItem(minus.dataset.key, Math.max(0, parseInt(minus.dataset.qty, 10) - 1));
      return;
    }

    const plus = e.target.closest('.js-cd-plus');
    if (plus) {
      updateItem(plus.dataset.key, parseInt(plus.dataset.qty, 10) + 1);
      return;
    }

    const remove = e.target.closest('.js-cd-remove');
    if (remove) {
      updateItem(remove.dataset.key, 0);
      return;
    }
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeCartDrawer();
  });

})();
